// Page frame for every Starter Tape screen: a small wordmark that links back
// to the hub, and a title block. The studio itself is neutral; each path
// brings its own backdrop and accent (`theme`), so Deep Space feels like
// space while Side A stays plain.

import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../lib/utils";

// A faint field of stars drawn with CSS gradients (no images).
const STARS = [
  "radial-gradient(1px 1px at 12% 18%, rgba(255,255,255,0.55), transparent)",
  "radial-gradient(1px 1px at 78% 12%, rgba(255,255,255,0.45), transparent)",
  "radial-gradient(1.5px 1.5px at 42% 8%, rgba(199,210,254,0.6), transparent)",
  "radial-gradient(1px 1px at 88% 44%, rgba(255,255,255,0.35), transparent)",
  "radial-gradient(1px 1px at 6% 62%, rgba(255,255,255,0.35), transparent)",
  "radial-gradient(1.5px 1.5px at 64% 30%, rgba(165,180,252,0.5), transparent)",
  "radial-gradient(1px 1px at 30% 40%, rgba(255,255,255,0.3), transparent)",
  "radial-gradient(ellipse at top, rgba(79,70,229,0.22), transparent 60%)",
].join(", ");

export const THEMES = {
  studio: {
    page: "bg-zinc-950",
    style: undefined,
    eyebrow: "text-amber-300",
  },
  deepSpace: {
    page: "bg-[#05060f]",
    style: { backgroundImage: STARS, backgroundAttachment: "fixed" },
    eyebrow: "text-indigo-300",
  },
};

export default function TapeShell({
  eyebrow,
  title,
  subtitle,
  theme = "studio",
  children,
}) {
  const t = THEMES[theme] || THEMES.studio;
  return (
    <div className={cn("min-h-screen text-zinc-100", t.page)} style={t.style}>
      <div className="mx-auto max-w-5xl px-4 py-8 sm:py-12">
        <header className="mb-6">
          <Link
            to="/starter-tape"
            className="text-xs uppercase tracking-[0.25em] text-zinc-500 hover:text-zinc-300"
          >
            Starter Tape
          </Link>
          {eyebrow && (
            <p className={cn("mt-3 text-sm font-medium", t.eyebrow)}>
              {eyebrow}
            </p>
          )}
          <h1 className="mt-1 text-3xl font-semibold sm:text-4xl">{title}</h1>
          {subtitle && (
            <p className="mt-2 max-w-2xl text-zinc-400">{subtitle}</p>
          )}
        </header>
        {children}
      </div>
    </div>
  );
}
